import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@ecom/ui/card';
import { trpc } from '@/index';

export const Route = createFileRoute('/(app)/')({
  component: DashboardPage,
});

function DashboardPage() {
  const now = new Date();
  const thirtyDaysAgo = new Date(now.getTime() - 30 * 86_400_000);
  const [overview] = trpc.analytics.overview.useSuspenseQuery({
    range: { from: thirtyDaysAgo, to: now },
  });

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <p className="text-muted-foreground">Last 30 days overview</p>
      </div>

      <div className="grid gap-4 md:grid-cols-4">
        <MetricCard label="GMV" value={`$${Number(overview.gmv).toLocaleString()}`} />
        <MetricCard label="Orders" value={overview.orderCount.toLocaleString()} />
        <MetricCard label="AOV" value={`$${overview.aov}`} />
        <MetricCard label="Shops" value={String(overview.shopCount)} />
      </div>

      {overview.shopCount === 0 && (
        <Card>
          <CardContent className="p-8 text-center">
            <p className="text-muted-foreground mb-3">
              No shops connected yet.
            </p>
            <a href="/shops/new" className="text-primary underline">
              Connect your first shop →
            </a>
          </CardContent>
        </Card>
      )}
    </div>
  );
}

function MetricCard({ label, value }: { label: string; value: string }) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {label}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
      </CardContent>
    </Card>
  );
}
